import React, { useState } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

// Generate 10 dummy topics
const topics = Array.from({ length: 10 }, (_, i) => `Topic ${i + 1}`);

export default function TopicMenu() {
  const [selectedTopics, setSelectedTopics] = useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedTopics(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <div>
      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel id="multiple-checkbox-label">Topics</InputLabel>
        <Select
          labelId="multiple-checkbox-label"
          id="multiple-checkbox"
          multiple
          value={selectedTopics}
          onChange={handleChange}
          input={<OutlinedInput label="Topics" />}
          renderValue={(selected) => selected.join(", ")}
          MenuProps={MenuProps}
          sx={{
            height: "40px",
            width: "800px",
            backgroundColor: "white",
            fontFamily: "'Host Grotesk', sans-serif",
            textTransform: "none",
            border: "1px solid rgba(0, 0, 0, 0.23)",
            borderRadius: "8px", // Rounded corners for input
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
          }}
        >
          {topics.map((topic) => (
            <MenuItem key={topic} value={topic}>
              <Checkbox checked={selectedTopics.includes(topic)} />
              <ListItemText primary={topic} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
